export default __webpack_public_path__ + "static/media/terms-of-service-consent-kr-3.58867386.jpg";